import React from "react";
import { motion } from "framer-motion";

export default function EventStaffingTestimonial() {
  return (
    <section className="es-testimonial-section">
      <div className="container-fluid horizontal-padding">
        <div className="es-testimonial-container">
          <motion.div
            className="es-testimonial-card"
            initial={{ opacity: 0, y: 35, scale: 0.98 }}
            whileInView={{ opacity: 1, y: 0, scale: 1 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.7, ease: "easeOut" }}
          >
            {/* Double Quote Icon */}
            <div className="es-quote-icon-wrap">
              <svg
                width="28"
                height="22"
                viewBox="0 0 28 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="es-quote-svg"
              >
                <path
                  d="M0 13.2C0 5.86667 4.2 0.866667 11.2 0V4.4C7.46667 4.4 5.33333 7.06667 5.06667 11.0667H11.2V22H0V13.2ZM16.8 13.2C16.8 5.86667 21 0.866667 28 0V4.4C24.2667 4.4 22.1333 7.06667 21.8667 11.0667H28V22H16.8V13.2Z"
                  fill="#ffffff"
                />
              </svg>
            </div>

            {/* Testimonial Quote Text */}
            <p className="es-testimonial-text">
              Sprigstack completely eliminated our scheduling chaos, replacing
              endless text threads with a centralized portal for game assignments
              and dealer approvals. It has given us the structure and visibility
              needed to scale our casino-night operations effortlessly.
            </p>

            {/* Attribution */}
            <div className="es-testimonial-author">
              <span className="es-author-dash">- </span>
              <span className="es-author-title">From Our Client</span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
